import { motion } from "framer-motion";
import * as icons from "lucide-react";
import { Reveal, SectionTag, MaskedLine } from "@/components/Reveal";
import { MILESTONES, SKILLS, STATS } from "@/data";

const GROUPS = ["ACADEMIC", "DUTA & YOUTH", "LEADERSHIP", "OTHER"];

const Achievements = () => (
  <motion.main
    initial={{ opacity: 0, y: 24 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -24 }}
    transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
    className="pt-28"
    data-testid="achievements-page"
  >
    <header className="px-6 md:px-12">
      <SectionTag no="06" label="ACHIEVEMENTS" />
      <h1 className="mt-8 font-display text-5xl font-black uppercase leading-[0.9] tracking-tighter sm:text-6xl md:text-8xl" data-testid="achievements-title">
        <MaskedLine delay={0.1}><span>MILE<span className="text-burgundy">STONES</span></span></MaskedLine>
      </h1>
      <Reveal delay={0.3}>
        <p className="mt-8 max-w-xl font-serif text-xl italic leading-relaxed text-ash md:text-2xl">
          Bukan daftar untuk dipamerkan — hanya penanda bahwa perjalanan ini benar-benar terjadi.
        </p>
      </Reveal>
    </header>

    {GROUPS.map((g) => (
      <section key={g} className="border-t border-ink/10 px-6 py-16 md:px-12" data-testid={`milestones-${g.toLowerCase().replace(/[\s&]+/g, "-")}`}>
        <p className="font-display text-[10px] font-bold uppercase tracking-[0.35em] text-burgundy">{g}</p>
        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {MILESTONES.filter((m) => m.group === g).map((m, i) => {
            const Icon = icons[m.icon] || icons.Star;
            return (
              <Reveal key={m.title} delay={i * 0.05}>
                <div
                  data-testid={`milestone-${m.title.toLowerCase().replace(/[\s&]+/g, "-")}`}
                  className="group relative border border-ink/15 p-7 transition-all duration-300 hover:-translate-y-1 hover:rotate-[-1deg] hover:border-burgundy hover:shadow-[8px_8px_0_0_#7A1C21]"
                >
                  <span className="flex h-12 w-12 items-center justify-center rounded-full bg-ink text-paper transition-colors duration-300 group-hover:bg-burgundy">
                    <Icon className="h-5 w-5" />
                  </span>
                  <h3 className="mt-5 font-display text-lg font-black uppercase leading-tight tracking-tight">{m.title}</h3>
                  <p className="mt-2 text-sm text-ash">{m.detail}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>
    ))}

    <section className="border-t border-ink/10 bg-cream px-6 py-20 md:px-12" data-testid="numbers-recap">
      <SectionTag no="Σ" label="BY THE NUMBERS" />
      <div className="mt-10 grid grid-cols-2 gap-px bg-ink/10 md:grid-cols-3 lg:grid-cols-6">
        {STATS.map((s, i) => (
          <div key={i} className="bg-cream p-6" data-testid={`recap-stat-${i}`}>
            <span className="font-display text-4xl font-black tracking-tighter text-burgundy">{s.value}</span>
            <p className="mt-2 font-display text-[10px] font-bold uppercase tracking-[0.2em]">{s.label}</p>
          </div>
        ))}
      </div>
    </section>

    <section className="bg-ink px-6 py-24 text-paper md:px-12" data-testid="skills-section">
      <SectionTag no="07" label="WHAT I WORK WITH" dark />
      <div className="mt-12 grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        {SKILLS.map((s, i) => (
          <Reveal key={s.group} delay={i * 0.06}>
            <div data-testid={`skills-${s.group.toLowerCase()}`}>
              <h3 className="font-display text-sm font-black uppercase tracking-[0.3em] text-ember">{s.group}</h3>
              <ul className="mt-5 space-y-2.5">
                {s.items.map((it) => (
                  <li key={it} className="border-b border-white/10 pb-2.5 font-display text-base font-bold uppercase tracking-tight text-paper/80 transition-colors hover:text-paper">
                    {it}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        ))}
      </div>
      <p className="mt-14 max-w-md text-xs text-paper/40">
        Tanpa progress bar palsu. Skill dinilai dari karya — cek halaman Creative.
      </p>
    </section>
  </motion.main>
);

export default Achievements;
